"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.itZones = exports.itSubZoneNameMapping = void 0;
var itZones = exports.itZones = [{
  id: 'BARI',
  name: 'Bari',
  country: 'IT',
  cornerNW: {
    latitude: 41.1327,
    longitude: 16.8119
  },
  cornerSE: {
    latitude: 41.0694,
    longitude: 16.8897
  },
  subZones: [{
    name: 'Bari',
    zipcodes: {
      70121: {
        label: 'Murat'
      },
      70122: {
        label: 'Madonnella'
      },
      70123: {
        label: 'San Nicola'
      },
      70124: {
        label: 'Carrassi'
      },
      70125: {
        label: 'Libertà'
      }
    }
  }]
}, {
  id: 'BOLOGNA',
  name: 'Bologne',
  country: 'IT',
  cornerNW: {
    latitude: 44.5127,
    longitude: 11.3119
  },
  cornerSE: {
    latitude: 44.4494,
    longitude: 11.3897
  },
  subZones: [{
    name: 'Bologne',
    zipcodes: {
      40121: {
        label: 'Centro Storico'
      },
      40122: {
        label: 'Santo Stefano'
      },
      40123: {
        label: 'Saragozza'
      },
      40124: {
        label: 'San Vitale'
      },
      40125: {
        label: 'Galvani'
      }
    }
  }]
}, {
  id: 'CATANIA',
  name: 'Catane',
  country: 'IT',
  cornerNW: {
    latitude: 37.5327,
    longitude: 15.0119
  },
  cornerSE: {
    latitude: 37.4694,
    longitude: 15.0897
  },
  subZones: [{
    name: 'Catane',
    zipcodes: {
      95121: {
        label: 'Centro'
      },
      95122: {
        label: 'Ognina-Picanello'
      },
      95123: {
        label: 'Borgo-Sanzio'
      },
      95124: {
        label: 'San Giovanni Galermo'
      },
      95125: {
        label: 'Librino'
      }
    }
  }]
}, {
  id: 'FLORENCE',
  name: 'Florence',
  country: 'IT',
  cornerNW: {
    latitude: 43.7897,
    longitude: 11.2119
  },
  cornerSE: {
    latitude: 43.7261,
    longitude: 11.2897
  },
  subZones: [{
    name: 'Florence',
    zipcodes: {
      50121: {
        label: 'Centro Storico'
      },
      50122: {
        label: 'San Giovanni'
      },
      50123: {
        label: 'Santa Maria Novella'
      },
      50124: {
        label: 'Isolotto'
      },
      50125: {
        label: 'Santo Spirito'
      }
    }
  }]
}, {
  id: 'GENOA',
  name: 'Gênes',
  country: 'IT',
  cornerNW: {
    latitude: 44.4527,
    longitude: 8.9119
  },
  cornerSE: {
    latitude: 44.3894,
    longitude: 8.9897
  },
  subZones: [{
    name: 'Gênes',
    zipcodes: {
      16121: {
        label: 'Centro Storico'
      },
      16122: {
        label: 'Carignano'
      },
      16123: {
        label: 'Portoria'
      },
      16124: {
        label: 'Foce'
      },
      16128: {
        label: 'San Vincenzo'
      }
    }
  }]
}, {
  id: 'MILAN',
  name: 'Milan',
  country: 'IT',
  cornerNW: {
    latitude: 45.5349,
    longitude: 9.1097
  },
  cornerSE: {
    latitude: 45.3894,
    longitude: 9.2276
  },
  subZones: [{
    name: 'Municipio 1 - Centro storico',
    zipcodes: {
      20121: {
        label: '20121'
      },
      20122: {
        label: '20122'
      },
      20123: {
        label: '20123'
      }
    }
  }, {
    name: 'Municipio 2 - Stazione Centrale, Gorla, Turro, Greco, Crescenzago',
    zipcodes: {
      20124: {
        label: '20124'
      },
      20125: {
        label: '20125'
      },
      20126: {
        label: '20126'
      },
      20127: {
        label: '20127'
      },
      20128: {
        label: '20128'
      }
    }
  }, {
    name: 'Municipio 3 - Città Studi, Lambrate, Venezia',
    zipcodes: {
      20129: {
        label: '20129'
      },
      20130: {
        label: '20130'
      },
      20131: {
        label: '20131'
      },
      20132: {
        label: '20132'
      },
      20133: {
        label: '20133'
      },
      20134: {
        label: '20134'
      }
    }
  }, {
    name: 'Municipio 4 - Vittoria, Forlanini',
    zipcodes: {
      20135: {
        label: '20135'
      },
      20137: {
        label: '20137'
      },
      20138: {
        label: '20138'
      },
      20139: {
        label: '20139'
      }
    }
  }, {
    name: 'Municipio 5 - Vigentino, Chiaravalle, Milanese, Gratosoglio',
    zipcodes: {
      20136: {
        label: '20136'
      },
      20140: {
        label: '20140'
      },
      20141: {
        label: '20141'
      },
      20142: {
        label: '20142'
      }
    }
  }, {
    name: 'Municipio 6 - Barona, Lorenteggio',
    zipcodes: {
      20143: {
        label: '20143'
      },
      20144: {
        label: '20144'
      },
      20146: {
        label: '20146'
      },
      20147: {
        label: '20147'
      }
    }
  }, {
    name: 'Municipio 7 - Baggio, De Angeli, San Siro',
    zipcodes: {
      20145: {
        label: '20145'
      },
      20148: {
        label: '20148'
      },
      20149: {
        label: '20149'
      },
      20152: {
        label: '20152'
      },
      20153: {
        label: '20153'
      }
    }
  }, {
    name: 'Municipio 8 - Fiera, Gallaratese, Quarto Oggiaro',
    zipcodes: {
      20150: {
        label: '20150'
      },
      20151: {
        label: '20151'
      },
      20154: {
        label: '20154'
      },
      20155: {
        label: '20155'
      },
      20156: {
        label: '20156'
      },
      20157: {
        label: '20157'
      }
    }
  }, {
    name: 'Municipio 9 - Stazione Garibaldi, Niguarda',
    zipcodes: {
      20158: {
        label: '20158'
      },
      20159: {
        label: '20159'
      },
      20160: {
        label: '20160'
      },
      20161: {
        label: '20161'
      },
      20162: {
        label: '20162'
      }
    }
  }]
}, {
  id: 'NAPLES',
  name: 'Naples',
  country: 'IT',
  cornerNW: {
    latitude: 40.8897,
    longitude: 14.2119
  },
  cornerSE: {
    latitude: 40.8261,
    longitude: 14.2897
  },
  subZones: [{
    name: 'Naples',
    zipcodes: {
      80121: {
        label: 'Chiaia'
      },
      80122: {
        label: 'Posillipo'
      },
      80133: {
        label: 'Centro Storico'
      },
      80134: {
        label: 'San Lorenzo'
      },
      80135: {
        label: 'Vomero'
      }
    }
  }]
}, {
  id: 'PALERMO',
  name: 'Palerme',
  country: 'IT',
  cornerNW: {
    latitude: 38.1727,
    longitude: 13.3119
  },
  cornerSE: {
    latitude: 38.0894,
    longitude: 13.3897
  },
  subZones: [{
    name: 'Palerme',
    zipcodes: {
      90121: {
        label: 'Centro Storico'
      },
      90133: {
        label: 'Kalsa'
      },
      90134: {
        label: 'Borgo Vecchio'
      },
      90141: {
        label: 'Politeama'
      },
      90144: {
        label: 'Libertà'
      }
    }
  }]
}, {
  id: 'ROME',
  name: 'Rome',
  country: 'IT',
  cornerNW: {
    latitude: 42.0505,
    longitude: 12.3828
  },
  cornerSE: {
    latitude: 41.7900,
    longitude: 12.6868
  },
  subZones: [{
    name: 'Municipio Roma I',
    zipcodes: {
      '00135': {
        label: '00135'
      },
      '00136': {
        label: '00136'
      },
      '00152': {
        label: '00152'
      },
      '00153': {
        label: '00153'
      },
      '00154': {
        label: '00154'
      },
      '00165': {
        label: '00165'
      },
      '00179': {
        label: '00179'
      },
      '00182': {
        label: '00182'
      },
      '00183': {
        label: '00183'
      },
      '00184': {
        label: '00184'
      },
      '00185': {
        label: '00185'
      },
      '00186': {
        label: '00186'
      },
      '00187': {
        label: '00187'
      },
      '00192': {
        label: '00192'
      },
      '00193': {
        label: '00193'
      },
      '00195': {
        label: '00195'
      },
      '00196': {
        label: '00196'
      },
      '00197': {
        label: '00197'
      },
      '00198': {
        label: '00198'
      }
    }
  }, {
    name: 'Municipio Roma II',
    zipcodes: {
      '00135': {
        label: '00135'
      },
      '00138': {
        label: '00138'
      },
      '00141': {
        label: '00141'
      },
      '00157': {
        label: '00157'
      },
      '00158': {
        label: '00158'
      },
      '00159': {
        label: '00159'
      },
      '00161': {
        label: '00161'
      },
      '00162': {
        label: '00162'
      },
      '00176': {
        label: '00176'
      },
      '00185': {
        label: '00185'
      },
      '00187': {
        label: '00187'
      },
      '00191': {
        label: '00191'
      },
      '00192': {
        label: '00192'
      },
      '00195': {
        label: '00195'
      },
      '00196': {
        label: '00196'
      },
      '00197': {
        label: '00197'
      },
      '00198': {
        label: '00198'
      },
      '00199': {
        label: '00199'
      }
    }
  }, {
    name: 'Municipio Roma III',
    zipcodes: {
      '00131': {
        label: '00131'
      },
      '00137': {
        label: '00137'
      },
      '00138': {
        label: '00138'
      },
      '00139': {
        label: '00139'
      },
      '00141': {
        label: '00141'
      },
      '00156': {
        label: '00156'
      },
      '00158': {
        label: '00158'
      },
      '00188': {
        label: '00188'
      },
      '00189': {
        label: '00189'
      },
      '00191': {
        label: '00191'
      },
      '00197': {
        label: '00197'
      },
      '00198': {
        label: '00198'
      }
    }
  }, {
    name: 'Municipio Roma IV',
    zipcodes: {
      '00131': {
        label: '00131'
      },
      '00132': {
        label: '00132'
      },
      '00137': {
        label: '00137'
      },
      '00141': {
        label: '00141'
      },
      '00155': {
        label: '00155'
      },
      '00156': {
        label: '00156'
      },
      '00157': {
        label: '00157'
      },
      '00158': {
        label: '00158'
      },
      '00159': {
        label: '00159'
      },
      '00162': {
        label: '00162'
      },
      '00176': {
        label: '00176'
      }
    }
  }, {
    name: 'Municipio Roma V',
    zipcodes: {
      '00133': {
        label: '00133'
      },
      '00155': {
        label: '00155'
      },
      '00159': {
        label: '00159'
      },
      '00169': {
        label: '00169'
      },
      '00172': {
        label: '00172'
      },
      '00173': {
        label: '00173'
      },
      '00175': {
        label: '00175'
      },
      '00176': {
        label: '00176'
      },
      '00177': {
        label: '00177'
      },
      '00181': {
        label: '00181'
      },
      '00182': {
        label: '00182'
      },
      '00185': {
        label: '00185'
      }
    }
  }, {
    name: 'Municipio Roma VI',
    zipcodes: {
      '00132': {
        label: '00132'
      },
      '00133': {
        label: '00133'
      },
      '00155': {
        label: '00155'
      },
      '00169': {
        label: '00169'
      },
      '00172': {
        label: '00172'
      },
      '00173': {
        label: '00173'
      },
      '00175': {
        label: '00175'
      }
    }
  }, {
    name: 'Municipio Roma VII',
    zipcodes: {
      '00118': {
        label: '00118'
      },
      '00133': {
        label: '00133'
      },
      '00154': {
        label: '00154'
      },
      '00169': {
        label: '00169'
      },
      '00173': {
        label: '00173'
      },
      '00174': {
        label: '00174'
      },
      '00175': {
        label: '00175'
      },
      '00176': {
        label: '00176'
      },
      '00178': {
        label: '00178'
      },
      '00179': {
        label: '00179'
      },
      '00181': {
        label: '00181'
      },
      '00182': {
        label: '00182'
      },
      '00183': {
        label: '00183'
      },
      '00184': {
        label: '00184'
      },
      '00185': {
        label: '00185'
      }
    }
  }, {
    name: 'Municipio Roma VIII',
    zipcodes: {
      '00134': {
        label: '00134'
      },
      '00142': {
        label: '00142'
      },
      '00143': {
        label: '00143'
      },
      '00144': {
        label: '00144'
      },
      '00145': {
        label: '00145'
      },
      '00146': {
        label: '00146'
      },
      '00147': {
        label: '00147'
      },
      '00153': {
        label: '00153'
      },
      '00154': {
        label: '00154'
      },
      '00174': {
        label: '00174'
      },
      '00178': {
        label: '00178'
      },
      '00179': {
        label: '00179'
      }
    }
  }, {
    name: 'Municipio Roma IX',
    zipcodes: {
      '00125': {
        label: '00125'
      },
      '00127': {
        label: '00127'
      },
      '00128': {
        label: '00128'
      },
      '00134': {
        label: '00134'
      },
      '00142': {
        label: '00142'
      },
      '00143': {
        label: '00143'
      },
      '00144': {
        label: '00144'
      },
      '00146': {
        label: '00146'
      },
      '00148': {
        label: '00148'
      },
      '00178': {
        label: '00178'
      }
    }
  }, {
    name: 'Municipio Roma X',
    zipcodes: {
      '00119': {
        label: '00119'
      },
      '00121': {
        label: '00121'
      },
      '00122': {
        label: '00122'
      },
      '00124': {
        label: '00124'
      },
      '00125': {
        label: '00125'
      },
      '00126': {
        label: '00126'
      },
      '00127': {
        label: '00127'
      },
      '00128': {
        label: '00128'
      },
      '00148': {
        label: '00148'
      }
    }
  }, {
    name: 'Municipio Roma XI',
    zipcodes: {
      '00125': {
        label: '00125'
      },
      '00126': {
        label: '00126'
      },
      '00127': {
        label: '00127'
      },
      '00144': {
        label: '00144'
      },
      '00146': {
        label: '00146'
      },
      '00148': {
        label: '00148'
      },
      '00149': {
        label: '00149'
      },
      '00151': {
        label: '00151'
      },
      '00153': {
        label: '00153'
      },
      '00163': {
        label: '00163'
      },
      '00166': {
        label: '00166'
      }
    }
  }, {
    name: 'Municipio Roma XII',
    zipcodes: {
      '00148': {
        label: '00148'
      },
      '00149': {
        label: '00149'
      },
      '00151': {
        label: '00151'
      },
      '00152': {
        label: '00152'
      },
      '00153': {
        label: '00153'
      },
      '00163': {
        label: '00163'
      },
      '00164': {
        label: '00164'
      },
      '00165': {
        label: '00165'
      },
      '00166': {
        label: '00166'
      }
    }
  }, {
    name: 'Municipio Roma XIII',
    zipcodes: {
      '00123': {
        label: '00123'
      },
      '00136': {
        label: '00136'
      },
      '00138': {
        label: '00138'
      },
      '00152': {
        label: '00152'
      },
      '00153': {
        label: '00153'
      },
      '00163': {
        label: '00163'
      },
      '00164': {
        label: '00164'
      },
      '00165': {
        label: '00165'
      },
      '00166': {
        label: '00166'
      },
      '00167': {
        label: '00167'
      },
      '00168': {
        label: '00168'
      }
    }
  }, {
    name: 'Municipio Roma XIV',
    zipcodes: {
      '00123': {
        label: '00123'
      },
      '00135': {
        label: '00135'
      },
      '00136': {
        label: '00136'
      },
      '00166': {
        label: '00166'
      },
      '00167': {
        label: '00167'
      },
      '00168': {
        label: '00168'
      }
    }
  }, {
    name: 'Municipio Roma XV',
    zipcodes: {
      '00123': {
        label: '00123'
      },
      '00135': {
        label: '00135'
      },
      '00138': {
        label: '00138'
      }
    }
  }]
}, {
  id: 'TURIN',
  name: 'Turin',
  country: 'IT',
  cornerNW: {
    latitude: 45.1127,
    longitude: 7.6119
  },
  cornerSE: {
    latitude: 45.0494,
    longitude: 7.6897
  },
  subZones: [{
    name: 'Circoscrizione I',
    zipcodes: {
      10121: {
        label: '10121'
      },
      10122: {
        label: '10122'
      },
      10123: {
        label: '10123'
      },
      10124: {
        label: '10124'
      },
      10128: {
        label: '10128'
      },
      10129: {
        label: '10129'
      }
    }
  }, {
    name: 'Circoscrizione II',
    zipcodes: {
      10126: {
        label: '10126'
      },
      10127: {
        label: '10127'
      },
      10135: {
        label: '10135'
      },
      10136: {
        label: '10136'
      },
      10137: {
        label: '10137'
      },
      10139: {
        label: '10139'
      }
    }
  }, {
    name: 'Circoscrizione III',
    zipcodes: {
      10138: {
        label: '10138'
      },
      10139: {
        label: '10139'
      },
      10141: {
        label: '10141'
      },
      10142: {
        label: '10142'
      }
    }
  }, {
    name: 'Circoscrizione IV',
    zipcodes: {
      10143: {
        label: '10143'
      },
      10144: {
        label: '10144'
      },
      10145: {
        label: '10145'
      }
    }
  }, {
    name: 'Circoscrizione V',
    zipcodes: {
      10147: {
        label: '10147'
      },
      10148: {
        label: '10148'
      },
      10149: {
        label: '10149'
      }
    }
  }, {
    name: 'Circoscrizione VI',
    zipcodes: {
      10154: {
        label: '10154'
      },
      10155: {
        label: '10155'
      },
      10156: {
        label: '10156'
      }
    }
  }, {
    name: 'Circoscrizione VII',
    zipcodes: {
      10152: {
        label: '10152'
      },
      10153: {
        label: '10153'
      },
      10132: {
        label: '10132'
      },
      10131: {
        label: '10131'
      }
    }
  }, {
    name: 'Circoscrizione VIII',
    zipcodes: {
      10125: {
        label: '10125'
      },
      10126: {
        label: '10126'
      },
      10134: {
        label: '10134'
      },
      10135: {
        label: '10135'
      },
      10136: {
        label: '10136'
      }
    }
  }]
}];

// INFO : these names are not used anymore, we keep them for now for backward compatibility
var itSubZoneNameMapping = exports.itSubZoneNameMapping = [{
  old: 'Milan',
  "new": 'Municipio 1 - Centro storico'
}, {
  old: 'Rome Centre historique',
  "new": 'Municipio Roma I'
}, {
  old: 'Rome Trastevere',
  "new": 'Municipio Roma I'
}, {
  old: 'Rome Parioli',
  "new": 'Municipio Roma II'
}, {
  old: 'Rome Monti',
  "new": 'Municipio Roma I'
}, {
  old: 'Rome Quartier vatican',
  "new": 'Municipio Roma I'
}, {
  old: 'Rome Prati',
  "new": 'Municipio Roma I'
}, {
  old: 'Rome Trieste',
  "new": 'Municipio Roma II'
}, {
  old: 'Turin',
  "new": 'Circoscrizione I'
}];